import React, { useEffect, useState } from "react";
export interface Props {onScroll : Function, scrollNumber : number, setScrollNumber : Function}
export const SectionNavigation:React.FC<Props> = ({onScroll, scrollNumber, setScrollNumber}) => {
    const index = [0,1,2,3,4,5]
    const [selIndex, setSelIndex] = useState<number>(0)
    const handleScroll = (index:number) => {
        // onScroll(index); 
        setSelIndex(index);
        setScrollNumber(index);
    }
    useEffect(()=>{
        onScroll(selIndex)
    }, [selIndex])
    return(
        <>
        <ul className="anchorBox">
            {index.map((list:number) => (
                <li key={list} className={list === scrollNumber ? 'active' : ''} onClick={()=>handleScroll(list)}>
                </li>
            ))}
        </ul>
        </>
    )
}